import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { Socket } from 'ngx-socket-io';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { UserService } from 'src/app/services/user/user.service';
import { environment } from 'src/environments/environment';
interface Notification {
  createdBy: any;
  user: any;
  id: string;
  message: string;
  isViewed: boolean;
  type: string;
  courseId?: number;
  navigation?: string;
  taskId?: number;
  messageThreadId?: number;
  forumId?: number;
  teacherAssistantId?: number;
  course: {
    id: number;
  };
  createdAt: string;
  response?: any;
}
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  loading: boolean = true;
  currentUser: any;
  email: string = '';
  emailInput: boolean = false;
  imgUrl: string = environment.imgBaseUrl;
  notifications: any = [];
  count: number = 0;
  currentDocument: any;
  private _docSub: Subscription = new Subscription();
  viewRequestSent: boolean = false;

  constructor(
    public router: Router,
    private authService: AuthService,
    private socket: Socket,
    private toastr: ToastrService,
    private notificationService: NotificationService,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.authService.getUser().subscribe((res) => {
      this.currentUser = res;
    });
    this.currentUser = JSON.parse(localStorage.getItem('user') || '');
    this.getNotifications();
    this.currentDocument = this.socket.fromEvent('user:' + this.currentUser.id);
    this._docSub = this.currentDocument.subscribe((notification: any) => {
      this.notifications.reverse();
      this.notifications.push(this.setNotificationData(notification));
      this.notifications.reverse();
      console.log(notification);
      this.toastr.show(notification.text);
    });
  }

  ngOnDestroy() {
    this._docSub.unsubscribe();
  }

  openMenu() {
    document.body.classList.add('small-screen-sidebar-active');
  }

  getNotifications() {
    this.count = 0;
    this.notificationService.getNotifications().subscribe((res) => {
      const notifications: Notification[] = res.body as Notification[];
      notifications.forEach((notification) => {
        this.notifications.push(this.setNotificationData(notification));
      });
      this.loading = false;
    });
  }

  setNotificationData(notification: Notification): Notification {
    if (!notification.isViewed) this.count++;
    if (
      notification.type == 'session_created' ||
      notification.type == 'session_updated' ||
      notification.type == 'enrollment_updated'
    ) {
      notification.course.id = notification.courseId || -1;
      localStorage.setItem('course', JSON.stringify(notification.course));
      notification.navigation = '/courses';
    } else if (notification.type == 'enrollment_removed') {
      notification.navigation = '/courses';
    } else if (notification.type == 'task_created') {
      notification.navigation = '/tasks/' + notification.taskId;
    } else if (notification.type == 'task_updated') {
      notification.navigation = '/tasks/' + notification.taskId;
    } else if (notification.type == 'task_deleted') {
      notification.navigation = '/tasks';
    } else if (notification.type == 'submission_graded') {
      notification.navigation = '/tasks/' + notification.taskId;
    } else if (notification.type == 'announcement_created') {
      notification.navigation = '/announcements';
    } else if (notification.type == 'message_created') {
      notification.navigation = '/messages/' + notification.messageThreadId;
    } else if (notification.type == 'appointment_status_updated') {
      notification.navigation = '/appointments';
    } else if (notification.type == 'appointment_created') {
      notification.navigation = '/appointments';
    } else if (notification.type == 'forum_created') {
      notification.navigation = '/forums/' + notification.forumId;
    } else if (notification.type == 'forum_reply_created') {
      notification.navigation = '/forums/' + notification.forumId;
    } else if (notification.type == 'ta_assigned') {
      notification.navigation =
        '/users/' + notification.teacherAssistantId + '/profile';
    } else if (notification.type == 'new_registration') {
      // notification.navigation = "/requests/registrations";
      notification.navigation = '/';
    } else if (notification.type == 'session_schedule_updated') {
      notification.navigation = '/courses';
    } else if (notification.type == 'account_verified') {
      notification.navigation = '/requests/registrations';
    } else if (
      notification.type == 'officeHours_deleted' ||
      notification.type == 'officeHours_created'
    ) {
      notification.navigation = '/users/' + this.currentUser.id + '/profile';
    } else {
      notification.navigation = '/';
    }
    notification.response = notification;
    notification.createdAt = moment(notification.createdAt).calendar();
    return notification;
  }

  notificationsViewed() {
    if (!this.viewRequestSent) {
      this.notificationService
        .notificationsViewed(this.currentUser.id)
        .subscribe((res) => {
          this.count = 0;
          this.viewRequestSent = true;
        });
    }
  }

  navigateTo(notification: Notification, index: string | number): void {
    if (this.router.url == notification.navigation) {
      window.location.reload();
    }
    if (notification.type == 'message_created') {
      var user = {
        userId: notification.createdBy,
        user: notification.user,
      };
      localStorage.setItem('chatUser', JSON.stringify(user));
    }
    this.notificationService
      .notificationClicked(notification.id)
      .subscribe((res) => {
        this.notifications[index].isClicked = '1';
      });
    this.router.navigate([notification.navigation]);
  }

  redirectTo(uri: string) {
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([uri]));
  }

  logOut() {
    this.authService.logOut();
  }
}
